export async function requestIdleCallback(cb: () => void): Promise<void> {
	const { request } = await import("requestidlecallback");
	request(cb);
}